<div class="content-section" [ngClass]="layoutService.expandedMenu ? 'expand' : ''">
    <app-trial-license-warning></app-trial-license-warning>
    <lib-campaigns></lib-campaigns>
    <div class="title-section title-bar title-bar-nav">
        <div class="title-div d-flex align-items-center">
            <div class="col p-0 d-flex justify-content-between align-items-center changeInstitution">
                <div class="p-0">
                    <h2 class="background_title">{{ 'LAYOUT_MODULE.EVALUATION' | translate }}</h2>
                </div>
                <div class="col-auto">
                    <div class="col-auto institution-name pl-0">
                        <!-- <img alt="Institution" src="assets/img/svg/icon-help.svg"> -->
                    </div>
                </div>

            </div>
        </div>
        <div class="container-nav">
            <nav class="nav nav-pills nav-title">
                <!-- <a class="nav-link " routerLink="/evaluation/reportSop"
                    routerLinkActive='active'>{{'EVALUATION.SUMMARISED_REPORT_OK' | translate }}</a> -->
                <a class="nav-link " routerLink="/evaluation/observeSOP" routerLinkActive='active'
                    *ngIf="roleId == 1 || roleId == 2 || roleId == 3 || isMyHygieneSOPLicense(packageID)">{{'EVALUATION.MY_HYGIENE_SOP'
                    | translate}}</a>
                <!-- Observation-->
                <a class="nav-link" routerLink="/evaluation/observeObservation/statistical" routerLinkActive='active'
                    *ngIf="roleId == 1 || roleId == 2 || roleId == 3 || isObserveLicense(packageID)">{{
                    this.translationKeys.LayoutModule.Observe |
                    translate }} </a>
                <a class="nav-link" routerLink="/evaluation/hygiene-check/statistical" routerLinkActive='active'
                    *ngIf="roleId == 1 || roleId == 2 || roleId == 3 || isHygieneCheckLicense(packageID)">{{
                    "LAYOUT_MODULE.HYGIENE_CHECK" |
                    translate }} </a>
                <a class="nav-link" routerLink="/evaluation/consumption/statistical"
                    routerLinkActive='active'>{{'CONFIGURE.CONSUMPTION'
                    | translate}}</a>
            </nav>
            <hr class="nav-separator">
        </div>
    </div>
    <div class="container-section-nav">
        <router-outlet></router-outlet>
    </div>
</div>
